module.exports = __webpack_public_path__ + "media/images/twitter-70f705dafe2b801a6c570e78c3cd46f1.svg";